export class SocialIntents extends HTMLElement
{

    $name = '';
    $email = '';
    $clinic = '';
    $clinic_id = '';
    $city_state = '';

    constructor()
    {
        super();
    }

    connectedCallback()
    {
        this.name = this.dataset.name || '';
        this.email = this.dataset.email || '';
        this.clinic = this.dataset.clinic || '';
        this.clinic_id = this.dataset.clinic_id || '';
        this.city_state = this.dataset.city_state || '';
        this.init();
    }
    init()
    {
        window.onSIApiReady = () => this.onSIApiReady();
    }

    onSIApiReady() 
    {
        this.initEventHandlers();
    }

    initEventHandlers()
    {
        SI_API.onChatOpened = () => this.onChatOpended();
        
        SI_API.onChatClosed = () => this.onChatClosed();

        SI_API.onChatEnded = () => this.onChatEnded();


    }

    onChatOpended()
    {

        SI_API.setChatInfo(
            this.name || "",
            this.email || "",
        );

        const params = [];
        params.push(
            { name: "clinic", value: this.clinic || "" },
            { name: "clinic_id", value: this.clinic_id || "" },
            { name: "city_state", value: this.city_state || "" }
        );
        SI_API.addParams(params);

    }

    onChatClosed()
    {
        console.log("Chat closed");
    }

    onChatEnded()
    {
        console.log("Chat ended");
    }


}

customElements.define('social-intents', SocialIntents);

